export default {
  common: {
    error: "Algo salió mal",
    reload: "Recargar",
    errorNotification: "Hemos sido notificados y lo arreglaremos lo antes posible. Si el problema persiste, por favor",
    contactUs: "contáctanos.",
    language: "Idioma",
    loading: "Cargando...",
    loadingText: "Cargando",
    save: "Guardar",
    savedSuccessfully: "Guardado Exitosamente",
    saving: "Guardando...",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    add: "Agregar",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpiar",
    preview: "Vista previa",
    default: "Por defecto: {{value}}",
    optional: "Opcional",
    required: "Requerido",
    noData: "Sin datos"
  },
  // Places navigation  
  places: {
    navigation: {
      locations: "Ubicaciones",
      cities: "Ciudades",
      regions: "Regiones", 
      countries: "Países",
      showOnMap: "Mostrar en mapa",
      addLocation: "Agregar ubicación"
    },
    welcome: {
      title: "Bienvenido a Locations So Super.",
      subtitle: "Selecciona una sección de la navegación para comenzar."
    }
  },

  // Cities section
  cities: {
    title: "Ciudades",
    resourceSingular: "ciudad",
    resourcePlural: "ciudades",
    headings: {
      name: "Nombre",
      status: "Estado",
      locations: "Ubicaciones", 
      region: "Región",
      country: "País"
    },
    breadcrumbs: {
      cities: "Ciudades"
    }
  },

  // Countries section  
  countries: {
    title: "Países",
    resourceSingular: "país", 
    resourcePlural: "países",
    headings: {
      name: "Nombre",
      status: "Estado",
      locations: "Ubicaciones",
      cities: "Ciudades",
      regions: "Regiones"
    },
    breadcrumbs: {
      countries: "Países"
    }
  },

  // Regions section
  regions: {
    title: "Regiones",
    resourceSingular: "región",
    resourcePlural: "regiones", 
    headings: {
      name: "Nombre",
      status: "Estado",
      locations: "Ubicaciones",
      cities: "Ciudades",
      country: "País"
    },
    breadcrumbs: {
      regions: "Regiones"
    }
  },

  // Map section
  map: {
    title: "Mapa",
    breadcrumbs: {
      locations: "Ubicaciones"
    }
  },

  // Import section
  import: {
    title: "Importar CSV",
    breadcrumbs: {
      locations: "Ubicaciones"
    },
    new: {
      title: "Importar ubicaciones por CSV",
      description: "Descarga una plantilla CSV de ejemplo para ver un ejemplo del formato requerido",
      sampleTemplate: "plantilla CSV de ejemplo",
      uploadAndContinue: "Subir y continuar",
      abortOnError: "Abortar en error",
      abortOnErrorHelp: "Si hay un error, la importación se abortará, mostrará el error y no se importarán ubicaciones.",
      needHelp: "¿Necesitas ayuda para importar ubicaciones?"
    },
    show: {
      title: "Importar CSV",
      youCanLeavePage: "Puedes dejar esta página",
      backgroundMessage: "Tu importación seguirá ejecutándose en segundo plano",
      importProgress: "Progreso de importación",
      imported: "Importado",
      suffix: "ubicaciones",
      importLog: "Registro de importación",
      cancelImport: "Cancelar importación",
      cancelConfirmation: {
        title: "Cancelar importación",
        message: "¿Estás seguro de que quieres cancelar este trabajo de importación? Esta acción no se puede deshacer.",
        note: "Nota: Para trabajos en progreso, el trabajo deberá completarse y se eliminará inmediatamente después.",
        yesCancel: "Sí, cancelar importación",
        noContinue: "No, continuar importación"
      },
      report: "Reporte",
      failedLocations: "Ubicaciones fallidas",
      uploadAnother: "Subir otro CSV",
      backToLocations: "Volver a ubicaciones",
      importSucceeded: "Importación exitosa",
      importFailed: "Importación fallida"
    },
    messages: {
      uploadSuccess: "CSV subido exitosamente",
      uploadError: "No se pudo subir el CSV",
      pending: "La importación aún no ha comenzado",
      inProgress: "Importación en progreso",
      completed: "Importación completada",
      invalidHeader: "Las siguientes columnas son requeridas",
      invalidCsvFile: "Archivo CSV inválido",
      aborted: "Importación abortada",
      failed: "Importación fallida",
      cancelled: "Importación cancelada"
    },
    errors: {
      csvTooLarge: "El CSV es demasiado grande",
      languageNotEnabled: "El idioma '{{language}}' no está habilitado para esta tienda. Por favor, habilítalo en Configuración > Idiomas primero.",
      fieldNotTranslatable: "El campo '{{field}}' no es traducible. Los campos traducibles son: {{fields}}",
      locationError: "Ubicación con slug: {{slug}} - {{error}}",
      planLimit: "Has alcanzado el límite de tu plan para ubicaciones"
    }
  },

  // Location form
  location: {
    index: {
      title: "Ubicaciones",
      addLocation: "Agregar ubicación",
      import: "Importar",
      noPrioritySet: "Sin prioridad establecida",
      published: "Publicado",
      draft: "Borrador",
      resourceSingular: "ubicación",
      resourcePlural: "ubicaciones",
      headings: {
        name: "Nombre",
        status: "Estado",
        city: "Ciudad", 
        region: "Región",
        country: "País",
        priority: "Prioridad"
      }
    },
    form: {
      title: "Agregar ubicación",
      editTitle: "Editar ubicación",
      basicInformation: "Información básica",
      name: "Nombre",
      namePlaceholder: "ej. Ladrillos de Brian",
      nameHelpDefault: "Por defecto: {{defaultName}}",
      details: "Detalles",
      description: "Descripción",
      descriptionPlaceholder: "Dile a los clientes qué hace especial a esta ubicación",
      address: "Dirección",
      addressPlaceholder: "123 Calle Principal, Ciudad, País",
      addressLine1: "Línea de dirección 1",
      addressLine2: "Línea de dirección 2",
      postalZipCode: "Código postal / ZIP",
      city: "Ciudad",
      stateProvinceRegion: "Estado / Provincia / Región",
      country: "País",
      phone: "Teléfono",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Correo electrónico",
      emailPlaceholder: "tienda@ejemplo.com",
      website: "Sitio web",
      websitePlaceholder: "https://www.ejemplo.com",
      image: "Imagen",
      imagePlaceholder: "Ingresa la URL de la imagen",
      status: "Estado",
      statusActive: "Activo",
      statusInactive: "Inactivo", 
      statusDraft: "Borrador",
      priority: "Prioridad",
      priorityHelpText: "Las ubicaciones con mayor prioridad aparecen primero en los resultados de búsqueda",
      findOnMapButton: "Encontrar en mapa"
    },
    validation: {
      addressNotFound: "No se pudo encontrar la dirección",
      createSuccess: "Ubicación creada exitosamente",
      updateSuccess: "Ubicación actualizada exitosamente", 
      checkFields: "Por favor revisa tus campos",
      findOnMap: "Por favor encuentra tu ubicación en el mapa antes de guardar"
    },
    errors: {
      loading: "Error al cargar ubicación"
    },
    actions: {
      save: "Guardar ubicación",
      delete: "Eliminar ubicación",
      preview: "Vista previa"
    },
    customFields: {
      title: "Campos personalizados",
      noCustomFields: "No hay campos personalizados configurados",
      configureFields: "Configurar campos",
      emptyState: "Aún no has configurado ningún campo personalizado. Los campos personalizados te permiten agregar información adicional específica para las necesidades de tu negocio."
    },
    openingHours: {
      title: "Horarios de apertura",
      checkboxLabel: "Esta ubicación tiene horarios de apertura y cierre",
      statusOpen: "Abierto",
      statusOpen24h: "Abierto 24H",
      statusClosed: "Cerrado",
      openingTimeLabel: "Hora de apertura",
      closingTimeLabel: "Hora de cierre",
      days: {
        monday: "Lunes",
        tuesday: "Martes", 
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Agregado recientemente",
        recentlyModified: "Modificado recientemente"
      },
      filters: {
        status: "Estado",
        taggedWith: "Etiquetado con",
        locationStatus: "Estado de ubicación",
        noTagsToShow: "No hay etiquetas para mostrar",
        searchPlaceholder: "Buscar"
      },
      bulkActions: {
        setPublished: "Marcar como publicado",
        setUnpublished: "Marcar como no publicado", 
        setPriority: "Establecer prioridad",
        deleteLocations: "Eliminar ubicaciones",
        exportCSV: "Exportar como CSV"
      },
      appliedFilters: {
        statusIs: "Estado es {{status}}",
        taggedWith: "Etiquetado con {{tag}}",
        nameIncludes: "Nombre incluye {{search}}"
      },
      modals: {
        deleteTitle: "Eliminar ubicaciones",
        deleteMessage: "¿Estás seguro de que quieres eliminar {{count}}?",
        deleteMessageAll: "¿Estás seguro de que quieres eliminar todas las ubicaciones?",
        prioritiseTitle: "Priorizar {{count}} ubicaciones",
        prioritiseTitleAll: "Priorizar todas las ubicaciones",
        delete: "Eliminar",
        cancel: "Cancelar"
      },
      emptyState: {
        noResultsHeading: "No se pudieron encontrar {{resourcePlural}}",
        noResultsText: "Intenta cambiar los filtros o el término de búsqueda",
        noDataHeading: "Agrega una ubicación para poblar {{resourcePlural}}",
        addLocation: "Agregar ubicación",
        importFromCSV: "Importar desde CSV"
      },
      pagination: {
        label: "Página {{page}} de {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Actualizado exitosamente",
        deletedSuccessfully: "Eliminado exitosamente", 
        exportedSuccessfully: "Exportado exitosamente",
        error: "Algo salió mal"
      }
    }
  },

    // SEO Editor
  seo: {
    title: "Contenido de la página",
    editTemplate: "Editar plantilla SEO",
    pageTitle: "Título", 
    pageDescription: "Descripción",
    metaTitle: "Título",
    metaDescription: "Descripción",
    urlHandle: "Identificador de URL",
    searchEnginePreview: "Vista previa del listado en buscadores",
    editMeta: "Editar Meta",
    previewMeta: "Vista previa Meta",
    loading: "Cargando...",
    editingLocaleHelp: "Editando contenido en {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Plantillas SEO",
    breadcrumbs: {
      seoTemplates: "Plantillas SEO"
    },
    template: {
      title: "Plantilla {{templateName}} - {{locale}}",
      discardChanges: "Descartar cambios"
    },
    form: {
      pageContent: "Contenido de la página",
      searchEnginePreview: "Vista previa del listado en buscadores",
      title: "Título",
      description: "Descripción",
      pageTitle: "Título de página",
      metaDescription: "Meta descripción",
      editingLocaleHelp: "Editando traducciones en {{locale}}. Los campos vacíos mostrarán el contenido de {{defaultLocale}}.",
      defaultValue: "Por defecto: {{value}}"
    },
    language: {
      label: "Idioma",
      defaultHelp: "Este es tu idioma por defecto",
      editingHelp: "Editando traducciones en {{locale}}. Los campos vacíos mostrarán el contenido en {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Múltiples idiomas no habilitados",
      enableInSettings: "Habilitar en Configuración",
      multipleLanguagesInfo: "Para gestionar plantillas SEO para múltiples idiomas, habilita la internacionalización en la configuración de idiomas. Actualmente mostrando solo plantillas en {{locale}}."
    },
    badges: {
      errors: "¡Errores!",
      unsaved: "Sin guardar"
    },
    messages: {
      saveSuccess: "Plantillas SEO guardadas exitosamente",
      saveError: "No se pudieron guardar las plantillas",
      error: "Error..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Información básica",
      name: "Nombre",
      save: "Guardar",
      saving: "Guardando...",
      cancel: "Cancelar",
      yourLocationsIn: "Tus ubicaciones en {{name}}",
      tableHeadings: {
        name: "Nombre",
        status: "Estado",
        city: "Ciudad",
        region: "Región",
        country: "País"
      },
      resourceName: {
        singular: "ubicación de {{name}}",
        plural: "ubicaciones en {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Mapa",
      tags: "Etiquetas",
      customFields: "Campos personalizados",
      languages: "Idiomas",
      plan: "Plan",
      addTag: "Agregar etiqueta",
      addField: "Agregar campo"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Termina pronto"
    },
    common: {
      loading: "Cargando...",
      error: "Error...",
      breadcrumbs: {
        settings: "Configuración"
      },
      skeleton: {
        customFields: "Campos personalizados",
        addField: "Agregar campo",
        name: "Nombre",
        contentType: "Tipo de contenido",
        usedIn: "Usado en",
        field: "Campo",
        fields: "Campos"
      },
      messages: {
        savedSuccessfully: "Configuración de {{setting}} guardada exitosamente",
        couldntSave: "No se pudo guardar la configuración de {{setting}}"
      }
    },
    map: {
      title: "Mapa",
      messages: {
        savedSuccessfully: "Configuración del mapa guardada exitosamente",
        couldntSave: "No se pudo guardar la configuración"
      },
      mapboxToken: {
        title: "Token de Mapbox",
        description: "Ingresa tu token de Mapbox para alimentar tu localizador de tiendas",
        label: "Token de Mapbox",
        placeholder: "Ingresa el token aquí para continuar usando tu mapa.",
        placeholderManaged: "Ingresa el token aquí para continuar usando tu mapa una vez que agotes las cargas gratuitas del mapa.",
        helpText: "Sigue nuestras instrucciones para crear una clave de Mapbox, luego pega tu clave arriba. Si tienes algún problema, ponte en contacto para obtener asistencia.",
        linkInstructions: "instrucciones para crear una clave de Mapbox",
        linkSupport: "ponte en contacto para obtener asistencia"
      },
      managedToken: {
        title: "Cargas del mapa",
        description: "Tienes hasta {{max}} cargas gratuitas del mapa con un token administrado, después de eso tendrás que crear tu propio token."
      },
      appearance: {
        title: "Apariencia",
        description: "Cambia los elementos visuales de tu mapa"
      },
      mapStyle: {
        title: "Estilo de mapa",
        options: {
          streets: "Calles",
          outdoors: "Exteriores",
          light: "Claro",
          dark: "Oscuro",
          satellite: "Satélite",
          satelliteStreets: "Calles satelitales",
          navigationDay: "Navegación diurna",
          navigationNight: "Navegación nocturna"
        }
      },
      searchBehaviour: {
        title: "Comportamiento de búsqueda",
        description: "Controla cómo los visitantes encuentran ubicaciones en tu mapa.",
        geolocateLabel: "Estimar automáticamente la ubicación del visitante y mostrar tiendas cercanas",
        geolocateHelp: "Si la geolocalización tiene éxito, el mapa se moverá para enfocarse cerca del visitante. Si no se puede encontrar una ubicación estimada, el mapa permanecerá en la posición inicial.",
        filterBehaviour: {
          title: "Comportamiento del filtro",
          all: {
            label: "Todas las etiquetas",
            help: "Para que una ubicación aparezca en los filtros, debe tener todas las etiquetas seleccionadas"
          },
          any: {
            label: "Cualquier etiqueta",
            help: "Para que una ubicación aparezca en los filtros, puede tener cualquiera de las etiquetas seleccionadas"
          }
        },
        keepSearchInView: {
          label: "Mantener marcador de búsqueda a la vista",
          help: "Cuando aparecen los resultados de búsqueda, el mapa hará zoom para mostrar todas las ubicaciones coincidentes"
        },
        distanceUnits: {
          title: "Unidades de distancia",
          km: "Kilómetros",
          miles: "Millas"
        },
        maxResults: {
          label: "Máx. resultados",
          help: "Limitar el número de ubicaciones mostradas en los resultados de búsqueda",
          options: {
            results30: "30 resultados"
          }
        },
        maxDistance: {
          label: "Distancia máxima",
          help: "Solo mostrar ubicaciones dentro de esta distancia del punto de búsqueda",
          options: {
            unlimited: "Ilimitado"
          }
        },
        showLocationNames: {
          label: "Mostrar nombres de ubicaciones en sugerencias",
          help: "Mostrar nombres de ubicaciones en las sugerencias de búsqueda"
        },
        sortByPriority: {
          label: "Ordenar por prioridad en lugar de distancia",
          help: "Se recomienda encarecidamente establecer una distancia máxima (que no sea Ilimitado) si esta casilla está marcada. De lo contrario, tus clientes verán ubicaciones lejanas que tienen alta prioridad listadas por encima de aquellas que están a una distancia razonable de ellos (o de su consulta de búsqueda, más específicamente)."
        }
      },
      searchResults: {
        title: "Resultados de búsqueda",
        description: "Controla cómo se devuelven las ubicaciones en tu mapa.",
        locationsLabel: "Texto de resultados de búsqueda",
        locationsHelp: "Texto mostrado sobre los resultados de búsqueda (ej., 'Mostrando 5 ubicaciones')",
        prefixLabel: "Prefijo de resultados de búsqueda",
        prefixHelp: "Texto mostrado antes del número de resultados"
      },
      popups: {
        title: "Ventanas emergentes",
        showPopups: {
          label: "Mostrar ventanas emergentes",
          help: "Mostrar detalles de ubicación cuando los visitantes hacen clic en los marcadores del mapa"
        }
             },
       whitelabel: {
         title: "Marca blanca",
         hideLabel: "Ocultar texto 'powered by'",
         hideHelp: "Eliminar nuestra marca de tu localizador de tiendas"
       }
    },
    languages: {
      title: "Idiomas",
      error: "Error...",
      messages: {
        savedSuccessfully: "Configuración de idiomas guardada exitosamente",
        couldntSave: "No se pudo guardar la configuración de idiomas"
      },
      banner: {
        upgradeTitle: "El soporte multi-idioma requiere actualización del plan",
        upgradeAction: "Actualizar a Superest",
        upgradeMessage: "Aún puedes cambiar tu idioma por defecto, pero habilitar múltiples idiomas requiere una actualización.",
        disabledMessage: "La configuración de múltiples idiomas está deshabilitada en tu plan actual"
      },
      defaultLanguage: {
        title: "Idioma por defecto", 
        description: "Elige tu idioma principal en el que se mostrará tu contenido.",
        label: "Idioma por defecto",
        help: "Este idioma se usará cuando no se solicite un idioma específico"
      },
      internationalization: {
        title: "Internacionalización",
        description: "Habilita múltiples idiomas. Llega a más clientes y mejora tu SEO.",
        enableLabel: "Habilitar múltiples idiomas",
        enableHelp: "Permitir que los clientes vean tu localizador de tiendas en diferentes idiomas"
      },
      supportedLanguages: {
        title: "Idiomas adicionales soportados",
        description: "Selecciona idiomas adicionales que quieres soportar. Una vez que hayas habilitado un idioma, verás la opción de proporcionar traducciones en toda la aplicación. Para idiomas soportados, las plantillas SEO por defecto, así como los temas de variables comunes se generarán automáticamente.",
        defaultLocaleNote: "Este es tu idioma por defecto y no puede ser deshabilitado",
        shopifyEnabled: {
          label: "Este idioma está habilitado en mi Tienda Shopify",
          importantNote: "Importante:",
          description: "Desmarca la casilla anterior si este idioma no está habilitado y publicado para tu tienda Shopify. Se recomienda habilitar el idioma para tu tienda Shopify primero yendo a Configuración > Idiomas en tu admin de Shopify si aún no lo has hecho para una mejor experiencia del cliente."
        },
        urlFormats: {
          cleanUrls: "URLs limpias:",
          betterSeo: "Mejor SEO y experiencia de usuario",
          queryUrls: "URLs con parámetros de consulta:",
          considerEnabling: "Considera habilitar en Shopify para mejores URLs"
        },
        preview: {
          button: "Vista previa",
          tooltip: "Vista previa del localizador de tiendas en {{language}}"
        },
        tooltips: {
          noTemplates: "No hay plantillas SEO por defecto disponibles para este idioma. Puedes crear traducciones personalizadas fácilmente."
        }
      }
    },
    tags: {
      title: "Etiquetas",
      addTag: "Agregar etiqueta",
      error: "Error",
      messages: {
        deletedSuccessfully: "Etiquetas eliminadas exitosamente",
        couldntDelete: "No se pudieron eliminar las etiquetas",
        savedSuccessfully: "Etiqueta guardada exitosamente",
        couldntSave: "Por favor verifica tus campos",
        tagDeleted: "Etiqueta eliminada exitosamente"
      },
      resourceName: {
        singular: "etiqueta",
        plural: "etiquetas"
      },
      filters: {
        anyGroup: "Cualquier grupo",
        inGroup: "En grupo",
        tagGroup: "Grupo de etiquetas"
      },
      appliedFilters: {
        inGroup: "En grupo {{group}}",
        nameContains: "Nombre de etiqueta contiene {{query}}"
      },
      bulkActions: {
        deleteTag: "Eliminar etiqueta",
        deleteTags: "Eliminar etiquetas"
      },
      form: {
        language: "Idioma",
        title: "Título",
        description: "Descripción",
        group: "Grupo",
        groupPlaceholder: "Seleccionar grupo",
        addGroup: "Agregar",
        editingTranslations: "Editando traducciones en {{language}}. Los campos vacíos mostrarán contenido de {{defaultLanguage}}.",
        defaultValue: "Por defecto: {{value}}",
        image: "Imagen",
        imageUrl: "URL de imagen"
      },
      actions: {
        save: "Guardar",
        deleteTag: "Eliminar etiqueta"
      },
      new: {
        title: "Agregar etiqueta",
        messages: {
          createSuccess: "Etiqueta creada exitosamente",
          checkFields: "Por favor verifica tus campos"
        },
        actions: {
          createTag: "Crear etiqueta"
        }
      }
    },
    customFields: {
      title: "Campos personalizados",
      addField: "Agregar campo",
      error: "Error",
      resourceName: {
        singular: "Campo",
        plural: "Campos"
      },
      headings: {
        name: "Nombre",
        contentType: "Tipo de contenido",
        usedIn: "Usado en"
      },
      emptyState: {
        heading: "Crear y administrar tus campos personalizados",
        createAction: "Crear campo",
        description: "Usa campos personalizados para atributos únicos sobre tus ubicaciones. Estos campos pueden ser cualquier cosa desde perfiles sociales hasta el nombre y correo del gerente de la tienda"
      },
      pluralization: {
        location: "ubicación",
        locations: "ubicaciones"
      },
      form: {
        name: "Nombre",
        contentType: "Tipo de contenido",
        key: "Clave",
        keyPrefix: "location.fields.",
        keyHelp: "Usa esta clave para acceder al contenido de {{name}} de una ubicación en tus plantillas liquid.",
        translations: {
          title: "Traducciones",
          showTranslations: "Mostrar traducciones",
          hideTranslations: "Ocultar traducciones",
          description: "Las traducciones son opcionales. Los campos vacíos mostrarán el nombre del campo en {{language}}.",
          nameTranslation: "Nombre ({{language}})",
          defaultValue: "Por defecto: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Campo guardado exitosamente",
        couldntSave: "No se pudo guardar el campo",
        deletedSuccessfully: "Campo eliminado exitosamente",
        couldntDelete: "No se pudo eliminar el campo"
      },
      actions: {
        delete: "Eliminar"
      },
      new: {
        title: "Agregar campo",
        messages: {
          savedSuccessfully: "Campo guardado exitosamente",
          couldntSave: "No se pudo guardar el campo"
        }
      },
      contentTypes: {
        text: "Texto",
        textArea: "Área de texto",
        email: "Correo electrónico",
        number: "Número",
        phoneNumber: "Número de teléfono",
        time: "Hora",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Error",
      changePlan: "Cambiar plan",
      usdPerMonth: "USD / mes",
      sections: {
        yourPlanIncludes: "Tu plan incluye",
        nextBillingDate: "Próxima fecha de facturación",
        trial: "Prueba"
      },
      banners: {
        planUpdated: "Tu plan ha sido actualizado",
        thankYouUpgrading: "¡Gracias por actualizar!",
        letUsKnow: "Haznos saber",
        improvementText: "si hay algo que podamos hacer mejor."
      },
      locations: {
        upTo: "Hasta",
        locations: "ubicaciones",
        unlimited: "Ubicaciones ilimitadas",
        used: "usado",
        ofUsed: "{{used}} de {{max}} usado"
      },
      trial: {
        daysLeft: "{{days}} días restantes",
        daysUsed: "{{used}} de {{total}}días usado",
        selectPlan: "Seleccionar un plan",
        currentPlan: "Plan actual",
        trialBadge: "Prueba",
        currentBadge: "Actual",
        yourTrialJustStarted: "Tu prueba acaba de comenzar",
        trialEndsAfterToday: "Tu prueba termina después de hoy",
        trialEndsTomorrow: "Tu prueba termina mañana",
        daysLeftInTrial: "{{days}} días restantes en tu prueba",
        continueAddingLocations: "Continúa agregando ubicaciones después del {{date}} seleccionando un plan",
        selectPlanToday: "Por favor selecciona un plan hoy para continuar agregando ubicaciones"
      },
      footer: {
        description: "Administra o cambia tu plan de Locations So Super. Ve nuestros",
        termsOfService: "términos de servicio",
        and: "y",
        privacyPolicy: "política de privacidad"
      },
      features: {
        analytics: {
          title: "Analíticas",
          description: "Descubre cómo las personas están usando tus ubicaciones y dónde están buscando"
        },
        internationalization: {
          title: "Soporte multi-idioma",
          description: "Mejora el SEO y llega a más clientes en mercados objetivo habilitando múltiples idiomas"
        },
        customThemes: {
          editLiquid: {
            title: "Editar plantillas liquid del tema",
            description: "Muestra los datos de ubicación de cualquier manera que te guste con acceso al liquid del tema"
          },
          editStructuredData: {
            title: "Editar datos estructurados del negocio",
            description: "Edita cómo Google entiende las páginas editando tus datos estructurados"
          }
        }
      },
      edit: {
        title: "Cambiar plan",
        allPlansInclude: "Todos los planes anteriores incluyen",
        needingMoreLocations: "¿Necesitas más ubicaciones?",
        footerQuestion: "¿Tienes alguna pregunta antes de comenzar?",
        sendMessage: "envíanos un mensaje",
        allFeatures: {
          seoDirectory: {
            title: "Directorio SEO y páginas de destino",
            description: "Crea automáticamente un directorio SEO de todas tus ubicaciones, ciudades y regiones"
          },
          mapPage: {
            title: "Página de mapa con búsqueda y filtro",
            description: "Busca y filtra todas tus ubicaciones en un mapa potenciado por mapbox"
          },
          tags: {
            title: "Etiquetas",
            description: "Crea etiquetas con imágenes y descripciones y agrúpalas"
          },
          openingHours: {
            title: "Horarios de apertura",
            description: "Configura y muestra los horarios de apertura para tus ubicaciones"
          },
          mapStyles: {
            title: "Estilos de mapa",
            description: "Cambia la apariencia de los mapas con varios estilos predefinidos"
          },
          customFields: {
            title: "Campos personalizados",
            description: "Agrega cualquier campo nuevo que quieras, desde enlaces sociales hasta gerente de tienda"
          },
          csvUpload: {
            title: "Cargar y exportar con CSV",
            description: "Carga y edita masivamente tus ubicaciones."
          },
          richSnippets: {
            title: "Fragmentos enriquecidos",
            description: "Ayuda a Google a entender mejor las páginas con datos estructurados de negocios locales"
          },
          directionsAndCalls: {
            title: "Direcciones y llamadas",
            description: "Los visitantes pueden obtener direcciones fácilmente y hacer llamadas a las ubicaciones"
          },
          languageSupport: {
            title: "Soporte de idiomas",
            description: "Cambia el idioma por defecto a algo distinto al inglés. Plantillas de traducción proporcionadas para 32 idiomas principales para una configuración fácil."
          }
        }
      },
      planCard: {
        bestToCustomize: "Mejor para personalizar",
        currentPlan: "Plan actual",
        chooseThisPlan: "Elegir este plan",
        locationsSection: "Ubicaciones",
        featuresSection: "Características",
        upTo: "Hasta",
        locations: "ubicaciones",
        tooltipTooManyLocations: "Tienes demasiadas ubicaciones y/o idiomas habilitados para este plan."
      },
      confirmation: {
        error: "Error confirmando plan"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temas",
    currentTheme: {
      title: "Tema actual",
      description: "Este es el tema que ven los clientes cuando visitan tu aplicación de ubicaciones."
    },
    themeLibrary: {
      title: "Biblioteca de temas", 
      description: "Gestiona los temas de tus ubicaciones. Agrega y publica temas para cambiar la apariencia de tu ubicación en línea."
    },
    skeleton: {
      currentThemeDescription: "Este es el tema que ven tus clientes cuando usan tu aplicación de ubicaciones."
    },
    modal: {
      overrideTitle: "¿Sobrescribir tema actual?",
      override: "Sobrescribir",
      cancel: "Cancelar",
      undoWarning: "Esta acción no se puede deshacer."
    },
    messages: {
      publishSuccess: "Tema publicado exitosamente",
      publishError: "No se pudo publicar el tema",
      error: "Algo salió mal"
    },
    emptyStates: {
      settings: {
        heading: "Este tema no tiene configuraciones",
        description: "Crea configuraciones en el editor de plantillas.",
        createSettings: "Crear configuraciones",
        upgradePlan: "Actualizar plan",
        upgradeRequired: "Actualizar plan para crear configuraciones"
      },
      language: {
        heading: "Este tema no tiene términos de idioma",
        description: "Crea términos de idioma en el editor de plantillas.",
        createLanguageTerms: "Crear términos de idioma",
        upgradePlan: "Actualizar plan",
        upgradeRequired: "Actualizar plan para crear términos de idioma"
      }
    },
    templates: {
      categories: {
        templates: "Plantillas",
        schemas: "Esquemas",
        styles: "Estilos",
        liquidReference: "Referencia de Liquid"
      },
      items: {
        landing: "Página de destino",
        directory: "Directorio",
        country: "País",
        region: "Región",
        city: "Ciudad",
        location: "Ubicación",
        language: "Idioma",
        settings: "Configuración",
        stylesheet: "Hoja de estilos"
      },
      errors: {
        errorsInTemplate: "Errores en la plantilla",
        error: "Error"
      },
      badges: {
        errors: "¡Errores!",
        unsaved: "Sin guardar"
      },
      actions: {
        viewTheme: "Ver tema",
        discard: "Descartar",
        save: "Guardar"
      }
    },
    language: {
      messages: {
        saveSuccess: "Traducciones del idioma del tema guardadas exitosamente",
        saveError: "No se pudo guardar el tema"
      },
      form: {
        language: "Idioma",
        defaultLanguageHelp: "Este es tu idioma por defecto",
        translationHelp: "Editando traducciones para {{selectedLocale}}. Los campos vacíos mostrarán contenido de {{defaultLocale}} (tu idioma por defecto)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Múltiples idiomas no habilitados",
          action: "Habilitar en Configuración",
          description: "Para gestionar traducciones para múltiples idiomas, habilita la internacionalización en tu configuración de idiomas. Actualmente mostrando solo traducciones de {{locale}}."
        },
        translating: {
          title: "Traduciendo de {{from}} a {{to}}",
          description: "Cualquier campo que dejes vacío automáticamente mostrará el contenido de {{defaultLocale}} a tus clientes. Solo traduce los campos donde quieras contenido diferente en {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Accede a los términos de idioma de {{category}} en liquid con {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Título",
        description: "Descripción",
        heading: "Encabezado",
        subheading: "Subencabezado",
        button_text: "Texto del botón",
        link_text: "Texto del enlace",
        placeholder: "Marcador de posición",
        label: "Etiqueta",
        help_text: "Texto de ayuda",
        error_message: "Mensaje de error",
        success_message: "Mensaje de éxito",
        
        // Opening hours
        Monday: "Lunes",
        Tuesday: "Martes",
        Wednesday: "Miércoles",
        Thursday: "Jueves",
        Friday: "Viernes",
        Saturday: "Sábado",
        Sunday: "Domingo",
        opening_hours_format: "Formato de horarios de apertura",
        closes_at_format: "Formato de cierre",
        opens_at_format: "Formato de apertura",
        opens_on: "Abre el",
        open_24h: "Abierto 24h",
        open: "Abierto",
        closed: "Cerrado",
        closes_at: "Cierra a las",
        opens_at: "Abre a las",
        
        // Map
        search_map: "Buscar mapa",
        search_area: "Buscar en esta área",
        view_map: "Mapa",
        view_list: "Lista",
        open_filters: "Filtros",
        stores_near_you: "Tiendas cerca de ti",
        header: "¡Encuentra una tienda!",
        search_placeholder: "Escribe un código postal o dirección...",
        no_listings: "Lo sentimos, no podemos encontrar ubicaciones para tu búsqueda. Intenta cambiar los filtros o la ubicación de búsqueda",
        
        // Directory
        view_directory: "Directorio de tiendas",
        
        // Location
        get_directions: "Direcciones",
        call: "Llamar",
        view_website: "Sitio web",
        email: "Correo electrónico",
        opening_hours_header: "Horarios de apertura",
        description_header: "Información",
        phone_number_header: "Teléfono",
        address_header: "Dirección",
        tag_groups_to_display: "Grupos de etiquetas a mostrar"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "General",
        navigation: "Navegación",
        forms: "Formularios",
        buttons: "Botones",
        messages: "Mensajes",
        errors: "Errores",
        opening_hours: "Horarios de apertura",
        map: "Mapa",
        directory: "Directorio",
        location: "Ubicación"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema guardado exitosamente",
        saveError: "No se pudo guardar el tema"
      },
      accessSettings: "Accede a la configuración de {{category}} en liquid con {{code}}",
      fields: {
        // Colors
        color_text: "Color del texto",
        color_text_heading: "Color del texto del encabezado",
        color_background: "Color de fondo",
        color_accent: "Color de acento",
        color_text_positive: "Color del texto positivo",
        color_text_negative: "Color del texto negativo",
        dark_theme: "Tema oscuro",
        color_marker: "Color del marcador",
        color_search_marker: "Color del marcador de búsqueda",
        
        // Typography
        base_font_size: "Tamaño de fuente base",
        
        // Buttons
        border_radius: "Radio del borde",
        
        // Images
        aspect_ratio: "Relación de aspecto",
        fit: "Ajuste",
        
        // Spacing
        page_width: "Ancho de página",
        page_width_small: "Ancho de página pequeño",
        gutter_desktop: "Canaleta de escritorio",
        gutter_mobile: "Canaleta móvil",
        desktop_vertical_spacing: "Espaciado vertical de escritorio",
        mobile_vertical_spacing: "Espaciado vertical móvil",
        
        // Breakpoints
        breakpoint_xs: "Punto de quiebre XS",
        breakpoint_sm: "Punto de quiebre SM",
        breakpoint_md: "Punto de quiebre MD",
        
        // Map
        search_on_move: "Buscar al mover",
        scroll_to_zoom: "Desplazarse para hacer zoom",
        
        // Landing page
        sidebar_width: "Ancho de barra lateral",
        sidebar_min_height: "Altura mínima de barra lateral",
        marker_image_src: "Fuente de imagen del marcador",
        show_filter_descriptions: "Mostrar descripciones de filtros",
        
        // Location page
        tag_groups_to_display: "Grupos de etiquetas a mostrar",
        tag_groups_to_display_as_icons: "Grupos de etiquetas a mostrar como iconos",
        show_related_locations: "Mostrar ubicaciones relacionadas",
        
        // Locations
        hide_regions: "Ocultar regiones"
      },
      categories: {
        colors: "Colores",
        typography: "Tipografía",
        buttons: "Botones",
        images: "Imágenes",
        spacing: "Espaciado",
        breakpoints: "Puntos de quiebre",
        map: "Mapa",
        landing_page: "Página de destino",
        location_page: "Página de ubicación",
        locations: "Ubicaciones"
      }
    },
    navigation: {
      sublimeTheme: "Tema Sublime",
      settings: "Configuración",
      language: "Idioma",
      templates: "Plantillas",
      changeTheme: "Cambiar tema",
      viewDirectory: "Ver directorio",
      viewLandingPage: "Ver página de destino"
    },
    card: {
      lastUpdated: "Última actualización",
      view: "Ver",
      customize: "Personalizar",
      publish: "Publicar",
      actions: "Acciones"
    }
  },

  // Analytics section
  analytics: {
    title: "Analíticas",
    timePeriods: {
      last7days: "Últimos 7 días",
      last30days: "Últimos 30 días"
    },
    comparison: {
      compareToPrevious: "Comparar con período anterior",
      stopComparing: "Dejar de comparar con período anterior"
    },
    sections: {
      searchLocations: "Buscar ubicaciones"
    },
    cards: {
      sessions: "Sesiones",
      topSearches: "Búsquedas principales",
      topLandingPageType: "Tipo de página de destino principal",
      topPageViewsBySession: "Vistas de página principales por sesión",
      topLocations: "Ubicaciones principales",
      topReferrers: "Referentes principales",
      searches: "Búsquedas",
      topLandingPagesBySession: "Páginas de destino principales por sesión"
    },
    chartLabels: {
      desktop: "Escritorio"
    }
  },

}; 